import React, { Component } from 'react';

class FormicaCounter extends Component<FormicaCounterProps> {
  render() {
    const { value } = this.props;
    return (
      <div className={'flex w-[110px] h-[34px] items-center rounded-xl border-[0.5px] border-f-black-4'}>
        <div onClick={this.decrease} className={'bg-white w-2/3 h-full rounded-l-xl flex items-center justify-center text-[15px] font-bold  cursor-pointer'}>
          -
        </div>
        <div className={'bg-[#FAFAFA] border-r border-l h-full w-full  flex items-center justify-center text-[13px] '}>{value}</div>
        <div onClick={this.increase} className={'bg-white w-2/3 h-full rounded-r-xl flex items-center justify-center text-[15px] font-bold cursor-pointer'}>
          +
        </div>
      </div>
    );
  }

  private increase = () => {
    const { value, onChange } = this.props;
    onChange(value + 1);
  };

  private decrease = () => {
    const { value, onChange } = this.props;
    if (value - 1 > -1) onChange(value - 1);
  };
}

interface FormicaCounterProps {
  value: number;
  onChange: (value: number) => void;
}

export default FormicaCounter;
